import React from "react";
import TitlePage from "../../../app/Title/TitlePage";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Divider from "@material-ui/core/Divider";

const GuaranteeSelectionView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            {props.messagesGrowl}
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TitlePage title="Control de Límite \ Selección de Garantías"/>
                    </Grid>
                    <Grid item xs={6}>
                        <Button
                            label="Buscar"
                            style={{'float': 'right'}}
                            onClick={props.getDataGuaranteeSelection}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>

                    <Grid item xs={12}>
                        <Button
                            label="Selección de Garantías"
                            style={{'float': 'right'}}
                            onClick={props.redirectEditGuaranteeSelection}
                            className="p-button-secondary"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            responsive={true}
                            value={props.dataGuaranteeSelection}
                            selectionMode="single"
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column field="nombre" header="Nombre"
                                    style={{textAlign: 'left'}} sortable={true}/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>

            {props.confirmationMessage}
        </React.Fragment>
    )
};

export default GuaranteeSelectionView;